import * as types from '../mutation-types'

const localStorageName = 'joint_touroku'

// the definition of initial state is required.
const state = {
  apiKey: '',
  selectedRoadNameExtremeMap: '',
  selectedRoadNameJointMaster: '',
}

try {
  const config = JSON.parse(localStorage.getItem(localStorageName))
  Object.keys(config).forEach(k => {
    state[k] = config[k]
  })
} catch (e) {}

const getters = {
  apiKey: state => state.apiKey
}

const actions = {
  get({ commit, state, getters }, { key }) {
    return Promise.resolve(state[key])
  },
  set({ commit, state, getters }, { key, val }) {
    const data = { [key]: val }
    commit(types.SET_LOCALSTORAGE, { data })
  },
}

const mutations = {
  [types.SET_LOCALSTORAGE](state, { data }) {
    Object.keys(data).forEach(k => {
      state[k] = data[k]
    })
    localStorage.setItem(localStorageName, JSON.stringify(state))
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
